export default __webpack_public_path__ + "static/soehne-web-halbfett-17bedf65e18fd864097ba5b74e0e47cb.eot";